export default "/images/vendor/quill/icons/list-bullet.svg?cb92933c891e9914f1ac99ea79305cd4";